// src/components/meeting/NoticeWidget.jsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getNotices } from "../../api/meeting";
import WidgetCard from "./WidgetCard";

const NoticeWidget = () => {
  const projectId = localStorage.getItem("projectId");

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const res = await getNotices({ project: projectId });
      setItems((res.data?.results || []).slice(0, 5)); // 최신 5개
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  function formatKoreanDate(datetime) {
    if (!datetime) return "";
    const d = new Date(datetime);

    return `${d.getFullYear()}년 ${d.getMonth() + 1}월 ${d.getDate()}일 
            ${String(d.getHours()).padStart(2, "0")}:${String(
      d.getMinutes()
    ).padStart(2, "0")}`;
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <WidgetCard
      title="공지사항"
      linkText="더보기"
      onLinkClick={() => navigate(`/project/${projectId}/meeting/notice`)}
    >
      {loading ? (
        <div className="text-sm text-gray-500 py-3">불러오는 중...</div>
      ) : items.length === 0 ? (
        <p className="text-gray-500 text-sm py-2">공지사항이 없습니다.</p>
      ) : (
        <ul className="space-y-2">
          {items.map((item, index) => (
            <li
              key={item.dns}
              onClick={() =>
                navigate(
                  `/project/${projectId}/meeting/notice/${item.dns}/view`
                )
              }
              className="cursor-pointer hover:bg-gray-50 px-2 py-1 rounded transition"
            >
              <div className="text-sm font-medium text-gray-700 truncate flex gap-1">
                <span className="text-gray-500">{index + 1}.</span>
                <span className="truncate">{item.title}</span>
              </div>

              <div className="text-xs text-gray-400 ml-4">
                {formatKoreanDate(item.created_at)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </WidgetCard>
  );
};

export default NoticeWidget;
